export const vatReturnLabels = {
    de: {
        search: 'Ursprungsdaten durchsuchen',
        title: 'Umsatzsteuervoranmeldung',
        notice: 'Vorbereitung aus festgeschriebenen Buchungen. Keine Übermittlung an das Finanzamt.',
        ready: 'Steuerlich zugeordnet und mit den Buchungen abgestimmt',
        blocked: 'Offene Prüfungen: {{count}}. Die Vorbereitung ist noch nicht vollständig.',
        form: 'Formularfelder 2026',
        exact: 'Genauer Betrag',
        declared: 'Formularbetrag',
        field: 'Kennzahl',
        sources: 'Steuerliche Ursprungsdaten',
        review: 'Steuerzuordnung prüfen',
        reviewHint: 'Prüfe den Originalnachweis. Die Zuordnung ergänzt die vorhandene Buchung; sie erzeugt keine neue Buchung. Eine Änderung benötigt eine neue geprüfte Version.',
        reason: 'Originalnachweis und Begründung',
        bucket: 'Steueranteil',
        addBucket: 'Steueranteil hinzufügen',
        classification: 'Steuerlicher Sachverhalt',
        flow: 'Richtung',
        SALE: 'Ausgang',
        PURCHASE: 'Eingang',
        rate: 'Steuersatz in %',
        net: 'Nettobemessungsgrundlage in EUR',
        legalTax: 'Gesetzliche Steuer in EUR',
        deductibleTax: 'Abziehbare Vorsteuer in EUR',
        output: 'Umsatzsteuer',
        input: 'Abziehbare Vorsteuer',
        payable: 'Vorauszahlung / Erstattung',
        rounding: 'Formularrundung gegenüber den Steuerkonten',
        roundingHint: 'Nettobasen werden erst nach dem Zusammenfassen auf volle Euro gekürzt. Steuerbeträge im Formular haben zwei Nachkommastellen; die Buchhaltung behält vier.',
        empty: 'Keine steuerlichen Vorgänge im gewählten Zeitraum.',
        preview: 'Zuordnung prüfen',
        apply: 'Geprüfte Zuordnung speichern',
        saved: 'Steuerzuordnung gespeichert',
        issuesOnly: 'Nur offene Prüfungen',
        allFlows: 'Alle Richtungen',
        sort: 'Ursprungsdaten sortieren',
        dateAsc: 'Datum aufsteigend',
        dateDesc: 'Datum absteigend',
        numberAsc: 'Belegnummer aufsteigend',
        numberDesc: 'Belegnummer absteigend',
        export: 'CSV exportieren',
        compare: 'Zeiträume vergleichen',
        comparisonFrom: 'Vergleich von',
        comparisonTo: 'Vergleich bis',
        comparison: 'Zeitraumvergleich',
        current: 'Aktueller Zeitraum',
        previous: 'Vergleichszeitraum',
        change: 'Änderung',
        viewComparison: 'Vergleichsursprünge anzeigen',
        periodTotals: 'Summen für den gesamten Zeitraum; die Suche filtert nur die Ursprungsdaten.',
        classes: {
            DOMESTIC: 'Inländischer steuerpflichtiger Umsatz',
            EU_SUPPLY: 'Steuerfreie innergemeinschaftliche Warenlieferung',
            EXEMPT_WITH_DEDUCTION: 'Steuerfrei mit Vorsteuerabzug, einschließlich Ausfuhr',
            EXEMPT_WITHOUT_DEDUCTION: 'Steuerfrei ohne Vorsteuerabzug',
            OUTGOING_REVERSE_CHARGE: 'Inländischer Ausgangsumsatz mit Steuerschuld des Empfängers',
            EU_SERVICE_SUPPLY: 'B2B-Dienstleistung im übrigen EU-Gebiet',
            FOREIGN_PLACE_SUPPLY: 'Sonstiger Leistungsort im Ausland',
            EU_ACQUISITION: 'Steuerpflichtiger innergemeinschaftlicher Erwerb',
            EU_ACQUISITION_EXEMPT: 'Steuerfreier innergemeinschaftlicher Erwerb',
            RC_EU_SERVICE: 'Empfängersteuer für EU-Dienstleistungen',
            RC_PROPERTY: 'Empfängersteuer für grunderwerbsteuerpflichtige Umsätze',
            RC_OTHER: 'Weitere Empfängersteuer nach § 13b',
            IMPORT_VAT: 'Einfuhrumsatzsteuer aus Zollnachweis',
            NO_GERMAN_VAT: 'Kein deutscher steuerbarer Erwerb oder Vorsteuerabzug',
        },
        issues: {
            CLASSIFICATION_REQUIRED: 'Steuerlichen Sachverhalt anhand des Originals zuordnen.',
            LEDGER_MISMATCH: 'Steuerquelle und festgeschriebene Steuerkonten stimmen nicht überein.',
            SOURCE_REVIEW_REQUIRED: 'Steuerliche Ursprungsdaten benötigen eine Prüfung.',
            FISCAL_RATE_REQUIRED: 'Ein geprüfter steuerlicher EUR-Kurs bzw. ein belegter EUR-Steuerbetrag fehlt.',
        },
        errors: {
            comparison: 'Geben Sie beide Datumswerte für den Vergleich an.',
            dateRange: 'Das Enddatum darf nicht vor dem Startdatum liegen.',
            year: 'Diese Formularversion unterstützt ausschließlich das Kalenderjahr 2026.',
            source: 'Steuerbetrag, Richtung und Sachverhalt passen nicht zusammen.',
            duplicateEvent: 'Ein steuerlicher Vorgang wurde mehrfach erfasst.',
            classification: 'Der steuerliche Sachverhalt ist nicht eindeutig.',
            reconciliation: 'Die Summe der zugeordneten Umsatzsteuer und Vorsteuer muss mit den Steuerkonten der ursprünglichen Buchung übereinstimmen.',
            request: 'Der Vorgang konnte nicht abgeschlossen werden. Die Eingaben bleiben erhalten.',
        },
    },
    en: {
        search: 'Search source evidence',
        title: 'German VAT return',
        notice: 'Preparation from posted journals. No submission to the tax authority.',
        ready: 'Tax classification reconciled with posted journals',
        blocked: '{{count}} unresolved reviews. This preparation is incomplete.',
        form: '2026 form fields',
        exact: 'Exact amount',
        declared: 'Form amount',
        field: 'Field number',
        sources: 'Tax source evidence',
        review: 'Review tax classification',
        reviewHint: 'Check the original evidence. Classification supplements the existing journal without posting again. A change requires a new reviewed version.',
        reason: 'Original evidence and reason',
        bucket: 'Tax allocation',
        addBucket: 'Add tax allocation',
        classification: 'Tax case',
        flow: 'Direction',
        SALE: 'Outgoing',
        PURCHASE: 'Incoming',
        rate: 'VAT rate in %',
        net: 'Net taxable basis in EUR',
        legalTax: 'Statutory VAT in EUR',
        deductibleTax: 'Deductible input VAT in EUR',
        output: 'Output VAT',
        input: 'Deductible input VAT',
        payable: 'Advance payment / refund',
        rounding: 'Form rounding compared with tax accounts',
        roundingHint: 'Net bases are aggregated before discarding fractional euros. Form tax amounts have two decimal places; journals retain four.',
        empty: 'No tax events in the selected period.',
        preview: 'Check classification',
        apply: 'Save reviewed classification',
        saved: 'Tax classification saved',
        issuesOnly: 'Unresolved reviews only',
        allFlows: 'All directions',
        sort: 'Sort sources',
        dateAsc: 'Date ascending',
        dateDesc: 'Date descending',
        numberAsc: 'Reference ascending',
        numberDesc: 'Reference descending',
        export: 'Export CSV',
        compare: 'Compare periods',
        comparisonFrom: 'Comparison from',
        comparisonTo: 'Comparison to',
        comparison: 'Period comparison',
        current: 'Current period',
        previous: 'Comparison period',
        change: 'Change',
        viewComparison: 'Show comparison sources',
        periodTotals: 'Totals cover the whole period; search only filters source evidence.',
        classes: {
            DOMESTIC: 'Domestic taxable supply',
            EU_SUPPLY: 'Exempt intra-community goods supply',
            EXEMPT_WITH_DEDUCTION: 'Exempt with deduction, including exports',
            EXEMPT_WITHOUT_DEDUCTION: 'Exempt without input VAT deduction',
            OUTGOING_REVERSE_CHARGE: 'Domestic outgoing reverse charge',
            EU_SERVICE_SUPPLY: 'B2B service supplied elsewhere in the EU',
            FOREIGN_PLACE_SUPPLY: 'Other foreign place of supply',
            EU_ACQUISITION: 'Taxable intra-community acquisition',
            EU_ACQUISITION_EXEMPT: 'Exempt intra-community acquisition',
            RC_EU_SERVICE: 'Recipient VAT on EU services',
            RC_PROPERTY: 'Recipient VAT on property transfer transactions',
            RC_OTHER: 'Other recipient VAT under § 13b',
            IMPORT_VAT: 'Import VAT supported by customs evidence',
            NO_GERMAN_VAT: 'No German taxable acquisition or input VAT deduction',
        },
        issues: {
            CLASSIFICATION_REQUIRED: 'Classify the tax case using original evidence.',
            LEDGER_MISMATCH: 'Tax source evidence differs from posted tax accounts.',
            SOURCE_REVIEW_REQUIRED: 'Tax source evidence needs review.',
            FISCAL_RATE_REQUIRED: 'A reviewed fiscal EUR rate or documented EUR tax amount is missing.',
        },
        errors: {
            comparison: 'Enter both comparison dates.',
            dateRange: 'The end date must not precede the start date.',
            year: 'This form version supports calendar year 2026 only.',
            source: 'The tax amount, direction and tax case are inconsistent.',
            duplicateEvent: 'A tax event was included more than once.',
            classification: 'The tax case is ambiguous.',
            reconciliation: 'Classified output VAT and input VAT totals must match the original journal tax accounts.',
            request: 'The action could not be completed. Your inputs are retained.',
        },
    },
    tr: {
        search: 'Kaynak kayıtları ara',
        title: 'Almanya KDV ön beyannamesi',
        notice: 'Kesinleştirilmiş muhasebe kayıtlarından hazırlık. Vergi dairesine gönderim yapılmaz.',
        ready: 'Vergi sınıflandırması muhasebe kayıtlarıyla mutabık',
        blocked: '{{count}} açık kontrol var. Hazırlık henüz tamamlanmadı.',
        form: '2026 form alanları',
        exact: 'Kesin tutar',
        declared: 'Form tutarı',
        field: 'Alan numarası',
        sources: 'Vergi kaynak belgeleri',
        review: 'Vergi sınıflandırmasını kontrol et',
        reviewHint: 'Asıl belgeyi kontrol edin. Sınıflandırma mevcut kaydı tamamlar; yeni muhasebe kaydı oluşturmaz. Değişiklik için yeni bir onaylı sürüm gerekir.',
        reason: 'Asıl belge kanıtı ve gerekçe',
        bucket: 'Vergi payı',
        addBucket: 'Vergi payı ekle',
        classification: 'Vergi durumu',
        flow: 'Yön',
        SALE: 'Çıkış',
        PURCHASE: 'Giriş',
        rate: 'KDV oranı, %',
        net: 'EUR cinsinden net matrah',
        legalTax: 'EUR cinsinden yasal KDV',
        deductibleTax: 'EUR cinsinden indirilebilir KDV',
        output: 'Hesaplanan KDV',
        input: 'İndirilebilir KDV',
        payable: 'Ön ödeme / iade',
        rounding: 'Form yuvarlamasının vergi hesaplarıyla farkı',
        roundingHint: 'Net matrahlar toplandıktan sonra tam euroya kırpılır. Formdaki vergi tutarları iki, muhasebe kayıtları dört ondalık basamak taşır.',
        empty: 'Seçilen dönemde vergi işlemi yok.',
        preview: 'Sınıflandırmayı kontrol et',
        apply: 'Kontrol edilen sınıflandırmayı kaydet',
        saved: 'Vergi sınıflandırması kaydedildi',
        issuesOnly: 'Yalnızca açık kontroller',
        allFlows: 'Tüm yönler',
        sort: 'Kaynakları sırala',
        dateAsc: 'Tarih artan',
        dateDesc: 'Tarih azalan',
        numberAsc: 'Referans artan',
        numberDesc: 'Referans azalan',
        export: 'CSV dışa aktar',
        compare: 'Dönemleri karşılaştır',
        comparisonFrom: 'Karşılaştırma başlangıcı',
        comparisonTo: 'Karşılaştırma bitişi',
        comparison: 'Dönem karşılaştırması',
        current: 'Geçerli dönem',
        previous: 'Karşılaştırılan dönem',
        change: 'Değişim',
        viewComparison: 'Karşılaştırma kaynaklarını göster',
        periodTotals: 'Toplamlar tüm dönemi kapsar; arama yalnızca kaynak belgeleri filtreler.',
        classes: {
            DOMESTIC: 'Yurt içi vergiye tabi işlem',
            EU_SUPPLY: 'Vergiden muaf AB içi mal teslimi',
            EXEMPT_WITH_DEDUCTION: 'İndirim hakkıyla muaf işlem, ihracat dahil',
            EXEMPT_WITHOUT_DEDUCTION: 'KDV indirim hakkı olmayan muaf işlem',
            OUTGOING_REVERSE_CHARGE: 'Alıcının vergi borçlusu olduğu yurt içi satış',
            EU_SERVICE_SUPPLY: 'Diğer AB ülkesinde B2B hizmet',
            FOREIGN_PLACE_SUPPLY: 'Diğer yurt dışı hizmet yeri',
            EU_ACQUISITION: 'Vergiye tabi AB içi edinim',
            EU_ACQUISITION_EXEMPT: 'Vergiden muaf AB içi edinim',
            RC_EU_SERVICE: 'AB hizmetlerinde alıcı KDV sorumluluğu',
            RC_PROPERTY: 'Gayrimenkul devir işlemlerinde alıcı KDV sorumluluğu',
            RC_OTHER: '§ 13b kapsamındaki diğer alıcı KDV sorumluluğu',
            IMPORT_VAT: 'Gümrük belgesine dayalı ithalat KDV’si',
            NO_GERMAN_VAT: 'Almanya’da vergiye tabi edinim veya KDV indirimi yok',
        },
        issues: {
            CLASSIFICATION_REQUIRED: 'Vergi durumunu asıl belgeye göre sınıflandırın.',
            LEDGER_MISMATCH: 'Vergi kaynağı kesinleştirilmiş vergi hesaplarıyla uyuşmuyor.',
            SOURCE_REVIEW_REQUIRED: 'Vergi kaynak belgeleri incelenmeli.',
            FISCAL_RATE_REQUIRED: 'Kontrol edilmiş vergi amaçlı EUR kuru veya belgeli EUR vergi tutarı eksik.',
        },
        errors: {
            comparison: 'Her iki karşılaştırma tarihini de girin.',
            dateRange: 'Bitiş tarihi başlangıç tarihinden önce olamaz.',
            year: 'Bu form sürümü yalnızca 2026 takvim yılını destekler.',
            source: 'Vergi tutarı, yön ve vergi durumu uyuşmuyor.',
            duplicateEvent: 'Bir vergi işlemi birden fazla kez dahil edildi.',
            classification: 'Vergi durumu belirsiz.',
            reconciliation: 'Sınıflandırılan hesaplanan ve indirilecek KDV toplamları asıl kaydın vergi hesaplarıyla eşleşmeli.',
            request: 'İşlem tamamlanamadı. Girdileriniz korundu.',
        },
    },
    fr: {
        search: 'Rechercher les données sources',
        title: 'Déclaration périodique de TVA allemande',
        notice: 'Préparation à partir des écritures validées. Aucune transmission à l’administration fiscale.',
        ready: 'Classement fiscal rapproché des écritures validées',
        blocked: '{{count}} contrôles à résoudre. Cette préparation reste incomplète.',
        form: 'Rubriques du formulaire 2026',
        exact: 'Montant exact',
        declared: 'Montant déclaré',
        field: 'Numéro de rubrique',
        sources: 'Justificatifs fiscaux',
        review: 'Contrôler le classement fiscal',
        reviewHint: 'Vérifiez le justificatif original. Le classement complète l’écriture existante sans nouvelle comptabilisation. Toute modification exige une nouvelle version contrôlée.',
        reason: 'Justificatif original et motif',
        bucket: 'Ventilation fiscale',
        addBucket: 'Ajouter une ventilation',
        classification: 'Régime fiscal',
        flow: 'Sens',
        SALE: 'Vente',
        PURCHASE: 'Achat',
        rate: 'Taux de TVA en %',
        net: 'Base nette en EUR',
        legalTax: 'TVA légale en EUR',
        deductibleTax: 'TVA déductible en EUR',
        output: 'TVA collectée',
        input: 'TVA déductible',
        payable: 'Acompte / remboursement',
        rounding: 'Écart d’arrondi du formulaire avec les comptes de TVA',
        roundingHint: 'Les bases nettes sont agrégées puis tronquées à l’euro entier. Les taxes du formulaire ont deux décimales ; les écritures en conservent quatre.',
        empty: 'Aucune opération fiscale sur la période choisie.',
        preview: 'Vérifier le classement',
        apply: 'Enregistrer le classement contrôlé',
        saved: 'Classement fiscal enregistré',
        issuesOnly: 'Contrôles non résolus uniquement',
        allFlows: 'Tous les sens',
        sort: 'Trier les données sources',
        dateAsc: 'Date croissante',
        dateDesc: 'Date décroissante',
        numberAsc: 'Référence croissante',
        numberDesc: 'Référence décroissante',
        export: 'Exporter le CSV',
        compare: 'Comparer les périodes',
        comparisonFrom: 'Comparaison du',
        comparisonTo: 'Comparaison au',
        comparison: 'Comparaison des périodes',
        current: 'Période actuelle',
        previous: 'Période comparée',
        change: 'Variation',
        viewComparison: 'Afficher les sources comparées',
        periodTotals: 'Les totaux couvrent toute la période ; la recherche filtre uniquement les justificatifs.',
        classes: {
            DOMESTIC: 'Opération intérieure imposable',
            EU_SUPPLY: 'Livraison intracommunautaire de biens exonérée',
            EXEMPT_WITH_DEDUCTION: 'Exonération avec déduction, exportations comprises',
            EXEMPT_WITHOUT_DEDUCTION: 'Exonération sans droit à déduction',
            OUTGOING_REVERSE_CHARGE: 'Vente intérieure avec autoliquidation',
            EU_SERVICE_SUPPLY: 'Service B2B dans un autre État de l’UE',
            FOREIGN_PLACE_SUPPLY: 'Autre lieu de prestation à l’étranger',
            EU_ACQUISITION: 'Acquisition intracommunautaire imposable',
            EU_ACQUISITION_EXEMPT: 'Acquisition intracommunautaire exonérée',
            RC_EU_SERVICE: 'Autoliquidation des services de l’UE',
            RC_PROPERTY: 'Autoliquidation des opérations immobilières',
            RC_OTHER: 'Autre autoliquidation selon § 13b',
            IMPORT_VAT: 'TVA à l’importation justifiée en douane',
            NO_GERMAN_VAT: 'Aucune acquisition taxable ni déduction allemande',
        },
        issues: {
            CLASSIFICATION_REQUIRED: 'Classer le régime fiscal à partir du justificatif original.',
            LEDGER_MISMATCH: 'Les justificatifs fiscaux diffèrent des comptes de TVA validés.',
            SOURCE_REVIEW_REQUIRED: 'Les justificatifs fiscaux doivent être contrôlés.',
            FISCAL_RATE_REQUIRED: 'Le taux fiscal EUR contrôlé ou le montant fiscal EUR justifié manque.',
        },
        errors: {
            comparison: 'Indiquez les deux dates de comparaison.',
            dateRange: 'La fin ne peut pas précéder le début.',
            year: 'Cette version du formulaire couvre uniquement l’année civile 2026.',
            source: 'Le montant de TVA, le sens et le régime fiscal sont incohérents.',
            duplicateEvent: 'Une opération fiscale a été incluse plusieurs fois.',
            classification: 'Le régime fiscal est ambigu.',
            reconciliation: 'Les totaux de TVA collectée et déductible classés doivent correspondre aux comptes fiscaux de l’écriture originale.',
            request: 'L’action a échoué. Vos saisies sont conservées.',
        },
    },
    es: {
        search: 'Buscar datos de origen',
        title: 'Declaración periódica de IVA alemán',
        notice: 'Preparación a partir de asientos contabilizados. Sin envío a la administración tributaria.',
        ready: 'Clasificación fiscal conciliada con los asientos',
        blocked: '{{count}} revisiones pendientes. La preparación está incompleta.',
        form: 'Casillas del formulario 2026',
        exact: 'Importe exacto',
        declared: 'Importe del formulario',
        field: 'Número de casilla',
        sources: 'Justificantes fiscales',
        review: 'Revisar clasificación fiscal',
        reviewHint: 'Compruebe el justificante original. La clasificación completa el asiento existente sin volver a contabilizar. Los cambios requieren una nueva versión revisada.',
        reason: 'Justificante original y motivo',
        bucket: 'Distribución fiscal',
        addBucket: 'Añadir distribución',
        classification: 'Supuesto fiscal',
        flow: 'Dirección',
        SALE: 'Salida',
        PURCHASE: 'Entrada',
        rate: 'Tipo de IVA en %',
        net: 'Base neta en EUR',
        legalTax: 'IVA legal en EUR',
        deductibleTax: 'IVA deducible en EUR',
        output: 'IVA devengado',
        input: 'IVA deducible',
        payable: 'Pago a cuenta / devolución',
        rounding: 'Diferencia de redondeo del formulario frente a las cuentas fiscales',
        roundingHint: 'Las bases netas se agregan antes de truncarlas a euros enteros. Los impuestos del formulario tienen dos decimales; los asientos conservan cuatro.',
        empty: 'No hay operaciones fiscales en el período seleccionado.',
        preview: 'Comprobar clasificación',
        apply: 'Guardar clasificación revisada',
        saved: 'Clasificación fiscal guardada',
        issuesOnly: 'Solo revisiones pendientes',
        allFlows: 'Todas las direcciones',
        sort: 'Ordenar datos de origen',
        dateAsc: 'Fecha ascendente',
        dateDesc: 'Fecha descendente',
        numberAsc: 'Referencia ascendente',
        numberDesc: 'Referencia descendente',
        export: 'Exportar CSV',
        compare: 'Comparar períodos',
        comparisonFrom: 'Comparación desde',
        comparisonTo: 'Comparación hasta',
        comparison: 'Comparación de períodos',
        current: 'Período actual',
        previous: 'Período comparado',
        change: 'Variación',
        viewComparison: 'Mostrar fuentes comparadas',
        periodTotals: 'Los totales abarcan todo el período; la búsqueda solo filtra los justificantes.',
        classes: {
            DOMESTIC: 'Operación interior sujeta a IVA',
            EU_SUPPLY: 'Entrega intracomunitaria de bienes exenta',
            EXEMPT_WITH_DEDUCTION: 'Exenta con derecho a deducción, incluidas exportaciones',
            EXEMPT_WITHOUT_DEDUCTION: 'Exenta sin derecho a deducción',
            OUTGOING_REVERSE_CHARGE: 'Venta interior con inversión del sujeto pasivo',
            EU_SERVICE_SUPPLY: 'Servicio B2B en otro país de la UE',
            FOREIGN_PLACE_SUPPLY: 'Otro lugar de prestación en el extranjero',
            EU_ACQUISITION: 'Adquisición intracomunitaria sujeta a IVA',
            EU_ACQUISITION_EXEMPT: 'Adquisición intracomunitaria exenta',
            RC_EU_SERVICE: 'IVA del destinatario por servicios de la UE',
            RC_PROPERTY: 'IVA del destinatario por operaciones inmobiliarias',
            RC_OTHER: 'Otro IVA del destinatario según § 13b',
            IMPORT_VAT: 'IVA de importación con justificante aduanero',
            NO_GERMAN_VAT: 'Sin adquisición sujeta ni deducción de IVA alemán',
        },
        issues: {
            CLASSIFICATION_REQUIRED: 'Clasifique el supuesto fiscal con el justificante original.',
            LEDGER_MISMATCH: 'El justificante fiscal difiere de las cuentas fiscales contabilizadas.',
            SOURCE_REVIEW_REQUIRED: 'Los justificantes fiscales requieren revisión.',
            FISCAL_RATE_REQUIRED: 'Falta un tipo fiscal EUR revisado o un impuesto EUR documentado.',
        },
        errors: {
            comparison: 'Introduzca ambas fechas de comparación.',
            dateRange: 'La fecha final no puede preceder a la inicial.',
            year: 'Esta versión del formulario solo admite el año natural 2026.',
            source: 'El impuesto, la dirección y el supuesto fiscal son incompatibles.',
            duplicateEvent: 'Una operación fiscal se ha incluido varias veces.',
            classification: 'El supuesto fiscal es ambiguo.',
            reconciliation: 'Los totales clasificados de IVA devengado y deducible deben coincidir con las cuentas fiscales del asiento original.',
            request: 'No se pudo completar la acción. Se conservan los datos introducidos.',
        },
    },
};
//# sourceMappingURL=vat-return.js.map